import { makeStyles } from "@material-ui/core";

export const useProductFormStyles = makeStyles(theme => ({
    inputContainer: {
        '& .Mui-error': {
          borderRadius: '4px',
        },
        '& .Mui-error::before': {
          visibility: 'hidden',
        },
        '& .Mui-error::after': {
          visibility: 'hidden',
        },
        '& p.Mui-error': {
          color: '#AB1F26',
        },
        '&  input:after': {
          borderBottom: 'none !important'
        },
        '& textarea':{
          border: `1px solid #171C1E !important`
        },
        '& .Mui-error textarea': {
          border: `1px solid #AB1F26 !important`
        },
        '&>div:after': {
            visibility: 'hidden',
          },
          '&>div::before': {
            visibility: 'hidden',
          },
        },
    drawer: {
      width: '640px',
      position: 'relative',
      marginLeft: 'auto',
      boxSizing: 'border-box',
 
      background: '#FFFFFF',
      top: 0,
      right: 0,
      height: '100vh',
    },
    configContainer: {
      marginTop: '12px',
      display: 'flex',
      flexDirection: 'row',
    },
    configLine: {
      width: '19px',
      height: 'inherit', //'calc(100% + 35px)',
      borderLeft: '6px solid #e0e1e9',
      marginLeft: '18px',
      marginTop: '-36px',
    },
    configContent: {
      flexGrow: 1
    },
    modalRoot: { position: 'static', top: '50px' },
    backdrop: {
      position: 'absolute',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 0,
    },
    formContainer: {
      padding: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: '16px',
      borderBottom: '1px solid #E0E1E9',
      padding: '12px 24px',
    },
    title: {
      fontWeight: 600,
      fontSize: '20px',
      lineHeight: '32px',
      color: '#171C1E',
      margin: 0,
    },
    closeButton: {
      padding: '8px',
      color: '#6A6E79',
      '&:hover': {
        backgroundColor: '#f8f9fa',
        color: '#171C1E',
      },
    },
    formContent: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '32px',
      padding: '24px',
    },
    formGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    sectionTitle: {
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '24px',
      color: '#171C1E',
      marginBottom: '16px',
      marginTop: '20px',
    },
    radioGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    radioOption: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 0,
      margin: 0,
    },
    radioContent: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
    },
    radioText: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: '12px',
    },
    radioLabel: {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '20px',
      color: '#0e2c37',
    },
    radioDescription: {
      fontSize: '14px',
      lineHeight: '20px',
      color: '#6c757d',
      marginTop: '2px',
    },
    badge: {
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '10px',
      fontWeight: 700,
      lineHeight: '12px',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    },
    teamBadge: {
      backgroundColor: '#ffc107',
      color: '#000000',
    },
    accountBadge: {
      backgroundColor: '#ffc107',
      color: '#000000',
    },
    organizationBadge: {
      backgroundColor: '#ffc107',
      color: '#000000',
    },
    openBadge: {
      backgroundColor: '#28a745',
      color: '#ffffff',
    },
    closedBadge: {
      backgroundColor: '#343a40',
      color: '#ffffff',
    },
    buttonsContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '12px',
      marginTop: 'auto',
      padding: '12px 24px',
      borderTop: '1px solid #E0E1E9',
    },
    cancelButton: {
      backgroundColor: 'transparent',
      border: '1px solid #dee2e6',
      color: '#495057',
      padding: '8px 24px',
      borderRadius: '4px',
      fontSize: '14px',
      fontWeight: 600,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#f8f9fa',
      },
    },
    createButton: {
      color: '#ffffff',
      padding: '8px 24px',
      borderRadius: '4px',
      fontSize: '14px',
      fontWeight: 600,
      textTransform: 'none',
      border: 'none',
      '&:disabled': {
        backgroundColor: '#e9ecef',
        color: '#6c757d',
      },
    },
    radioControl: {
      '& .MuiRadio-root': {
        padding: '8px',
        color: '#dee2e6',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '20px',
      },
      '& .Mui-checked .MuiSvgIcon-root': {
        color: '#0d6efd',
      },
    },
    checkboxGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    checkboxOption: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    checkboxContent: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
    },
    checkboxText: {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: '8px',
    },
    checkboxLabel: {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '20px',
      color: '#0e2c37',
    },
    checkboxDescription: {
      fontSize: '14px',
      lineHeight: '20px',
      color: '#6c757d',
      marginTop: '2px',
    },
    checkboxControl: {
      '& .MuiCheckbox-root': {
        padding: '8px',
        color: '#dee2e6',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '20px',
      },
      '& .Mui-checked .MuiSvgIcon-root': {
        color: '#0d6efd',
      },
    },
    redirectUrlsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    redirectUrlRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      '&:first-of-type $deleteButton': {
        visibility: 'hidden',
      },
    },
    redirectUrlInput: {
      flex: 1,
      minWidth: 0,
      margin: '0 !important',
    },
    deleteButton: {
      padding: '8px',
      color: '#6c757d',
      '&:hover': {
        backgroundColor: '#f8f9fa',
        color: '#dc3545',
      },
    
    },
    addAnotherButton: {
      alignSelf: 'flex-start',
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 600,
      marginTop: '16px',
      padding: '4px 0',
      '&:hover': {
        backgroundColor: 'transparent',
        textDecoration: 'underline',
      },
    },
    maxUrlsNotice: {
      backgroundColor: '#F1F1F6',
      border: '1px solid #e0e1e9',
      borderRadius: '4px',
      padding: '12px',
      marginTop: '10px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '14px',
      color: '#495057',
      borderLeft: '4px solid #e0e1e9',
      "& svg": {
        fill: '#171C1E',
      },
    },
    /** Banner when editing a product that is already public (locked settings) */
    publicEditBanner: {
      margin: '24px 24px 0',
      padding: '12px 16px',
      backgroundColor: '#f5f5f6',
      border: '1px solid #e0e1e9',
      borderLeft: '4px solid #E0E1E9',
      borderRadius: '8px',
      display: 'flex',
      gap: '12px',
      alignItems: 'flex-start',
    },
    publicEditBannerIcon: {
      color: '#6A6E79',
      fontSize: '22px',
      marginTop: '2px',
      flexShrink: 0,
    },
    publicEditBannerText: {
      flex: 1,
      minWidth: 0,
    },
    publicEditBannerTitle: {
      fontWeight: 700,
      fontSize: '14px',
      lineHeight: '20px',
      color: '#171C1E',
      marginBottom: '4px',
     
    },
    publicEditBannerBody: {
      fontSize: '14px',
      lineHeight: '20px',
      color: '#171C1E',
      '& strong': {
        color: '#171C1E',
        fontWeight: 700,
      },
    },
    publicEditBannerLink: {
      color: '#0063a3',
      textDecoration: 'none',
      fontWeight: 600,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    /** Visibility radios when entire section locked (persisted public) */
    visibilityRadiosPublicLocked: {
      '& .MuiRadio-root': {
        color: '#cfd2d8',
      },
      '& .MuiRadio-root.Mui-checked': {
        color: '#9aa0a8 !important',
      },
      '& .MuiRadio-root.Mui-checked .MuiSvgIcon-root': {
        color: '#9aa0a8 !important',
      },
      '& .MuiRadio-root.Mui-disabled': {
        color: '#d8dce2',
      },
      '& .MuiRadio-root.Mui-disabled.Mui-checked': {
        color: '#9aa0a8 !important',
      },
      '& .MuiRadio-root.Mui-disabled.Mui-checked .MuiSvgIcon-root': {
        color: '#9aa0a8 !important',
      },
    },
    radioLabelLockedPublic: {
      color: '#8a9099 !important',
      fontWeight: 600,
    },
    radioDescriptionLockedPublic: {
      color: '#b3b8bf !important',
    },
    /** Application type row: locked (already on public product) */
    checkboxControlLockedPublic: {
      '& .MuiCheckbox-root': {
        color: '#d4d6db',
      },
      '& .MuiCheckbox-root.Mui-checked': {
        color: '#b8bcc4 !important',
      },
      '& .MuiCheckbox-root.Mui-disabled.Mui-checked': {
        color: '#b8bcc4 !important',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '20px',
      },
    },
    checkboxLabelLockedPublic: {
      color: '#8a9099 !important',
      fontWeight: 600,
    },
    checkboxDescriptionLockedPublic: {
      color: '#b3b8bf !important',
    },
    subscriptionPublicNotice: {
      marginBottom: 16,
      backgroundColor: '#f5f5f6',
      border: '1px solid #e0e1e9',
      borderLeft: '4px solid #E0E1E9',
      borderRadius: '4px',
      padding: '10px 12px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '14px',
      color: '#6A6E79',
      '& svg': {
        color: '#6A6E79',
        fontSize: '20px',
      },
    },
    /** "Make this product public?" modal — matches design spec (title/body colors, gray Cancel + primary CTA). */
    makePublicDialogPaper: {
      borderRadius: 16,
      boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
      maxWidth: 480,
      width: '100%',
    },
    makePublicDialogTitleRoot: {
      padding: '32px 32px 0',
    },
    makePublicDialogTitleText: {
      fontSize: 18,
      fontWeight: 600,
      lineHeight: '24px',
      color: '#171C1E',
      letterSpacing: 0,
      margin: 0,
    },
    makePublicDialogContent: {
      padding: '16px 32px 0',
      '&:first-of-type': {
        paddingTop: 16,
      },
    },
    makePublicDialogBody: {
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 400,
      color: '#363545',
      margin: 0,
      '& strong': {
        fontWeight: 600,
        color: '#171C1E',
      },
    },
    makePublicDialogActions: {
      padding: '24px 32px 32px',
      justifyContent: 'flex-end',
      flexWrap: 'nowrap',
      '& > :not(:first-child)': {
        marginLeft: 12,
      },
    },
    makePublicDialogCancelButton: {
      backgroundColor: '#F0F1F5 !important',
      color: '#171C1E !important',
      boxShadow: 'none !important',
      padding: '8px 22px',
      minWidth: 88,
      borderRadius: 8,
      fontSize: 14,
      fontWeight: 600,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#E2E2E7 !important',
      },
    },
    makePublicDialogConfirmButton: {
      backgroundColor: '#0D6AA8 !important',
      color: '#FFFFFF !important',
      boxShadow: 'none !important',
      padding: '8px 22px',
      minWidth: 120,
      borderRadius: 8,
      fontSize: 14,
      fontWeight: 600,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#07599B !important',
      },
      '&.Mui-disabled': {
        backgroundColor: '#BFBFC6 !important',
        color: '#FFFFFF !important',
      },
    },
  }));
  